import { Button } from '@quadminds/mindkit';
import { X, FileText, FileImage, FileSpreadsheet, Presentation, FileArchive, FileCode, File } from 'lucide-react';
import React from 'react';

interface FileItemProps {
    file: {
        name: string;
        size: number;
        type: string;
        preview: string;
    };
    onRemove?: () => void;
    isLoading: boolean;
}

// Función para obtener el icono según el tipo de archivo
const getFileIcon = (fileType: string) => {
    if (fileType.startsWith('image/')) return <FileImage />;
    if (fileType.includes('pdf')) return <FileText />;
    if (fileType.includes('word')) return <FileText />;
    if (fileType.includes('excel') || fileType.includes('spreadsheet')) return <FileSpreadsheet />;
    if (fileType.includes('powerpoint')) return <Presentation />;
    if (fileType.includes('zip') || fileType.includes('rar')) return <FileArchive />;
    if (fileType.includes('code')) return <FileCode />;
    return <File />;
};

const fileName = (name: string) => {
    return name.substr(name.lastIndexOf('\\') + 1).split('.')[0];
};

const formatExtension = (fileType: string) => {
    const extension = fileType.split('/')[1];
    return extension.toUpperCase();
};

// Componente FileItem
const FileItem: React.FC<FileItemProps> = ({ file, onRemove, isLoading }) => {
    return (
        <div className="flex flex-col space-y-1.5 border border-gray-qm-100 bg-gray-qm-50 dark:border-gray-qm-600 dark:bg-gray-qm-800 rounded-lg shadow-sm p-2">
            <div className="flex items-center space-x-2 flex-grow">
                <div className="flex items-center space-x-2 flex-grow min-w-0">
                    <div className="bg-tertiary-qm-400 p-2 rounded-sm text-white shrink-0">
                        {getFileIcon(file.type)}
                    </div>
                    <div className="flex flex-col -space-y-1 min-w-0 w-full pr-1">
                        <p className="text-background-foreground font-medium font-poppins truncate">
                            {fileName(file.name)}
                        </p>
                        <p className="text-muted-foreground text-sm truncate">{formatExtension(file.type)}</p>
                    </div>
                </div>
                {onRemove && (
                    <Button
                        size="icon"
                        variant="ghost"
                        onClick={onRemove}
                        className="!h-8 !w-8 hover:bg-background hover:text-background-foreground shrink-0"
                    >
                        <X size="14" />
                    </Button>
                )}
            </div>
            {isLoading && (
                <div className="h-1 rounded w-full animate-gradientSlide bg-gradient-to-r from-gray-qm-100/50 dark:from-gray-qm-500/50 via-gray-qm-200 dark:via-gray-qm-500 to-primary-100/50 dark:to-primary-100/50 bg-[length:200%]"></div>
            )}
        </div>
    );
};

export default FileItem;
